import { useState, useMemo } from 'react';

import { PROJECT_TEMPLATE } from 'constants/commonConstants';

const useProjectTemplate = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = useMemo(
    () =>
      Object.keys(PROJECT_TEMPLATE).map((key) => ({
        key,
        name: PROJECT_TEMPLATE[key].name,
        icon: PROJECT_TEMPLATE[key].icon,
      })),
    []
  );
  const templates = useMemo(() => {
    if (selectedCategory === 'all') {
      return Object.values(PROJECT_TEMPLATE).reduce(
        (acc, cnt) => [...acc, ...cnt.templates],
        [] as {
          id: string;
          category: string;
          title: string;
          description: string;
        }[]
      );
    }

    return PROJECT_TEMPLATE[selectedCategory].templates;
  }, [selectedCategory]);

  const handleCategoryClick = (categoryKey: string) => {
    setSelectedCategory(categoryKey);
  };

  return {
    selectedCategory,
    categories,
    templates,
    onCategoryClick: handleCategoryClick,
  };
};

export default useProjectTemplate;
